import React from "react";
import {
  Container,
  Text,
  Input,
  InputContainer,
  withStyles,
  SocialShares,
  referralLink,
  ReferralLinkButton
} from "components/common";
import { colors } from "theme";

const ReferralLink = ({ user }) => {
  return (
    <Container paddingHorizontal={32} paddingVertical={28} className="w-full">
      <Text className="font-title pb-4 font-bold text-lg md:text-xl">
        Your referral link
      </Text>
      <InputContainer backgroundColor="#F8F9F9">
        <Input value={referralLink(user)} className="referralLinkInput" />
      </InputContainer>
      <div className="mt-4 flex flex-col justify-between lg:flex-row">
        <ReferralLinkButton user={user} className="w-full" paddingHorizontal={32}>Copy Link</ReferralLinkButton>
        <div className="flex items-center mt-6 justify-center lg:mt-0 lg:justify-start">
          <Text className="text-gray-primary">Share on:</Text>
          <SocialShares
            size={24}
            iconBgColor={colors["gray-primary"]}
            logoColor="white"
            url={referralLink}
          />
        </div>
      </div>
    </Container>
  );
};

export default withStyles(ReferralLink);
